import { render } from "./DocumentsOption.vue?vue&type=template&id=6997ff18&scoped=true"
import script from "./DocumentsOption.vue?vue&type=script&lang=js"
export * from "./DocumentsOption.vue?vue&type=script&lang=js"

import "./DocumentsOption.vue?vue&type=style&index=0&id=6997ff18&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6997ff18"]])

export default __exports__